import React, { useEffect, useState } from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import { API_URLS } from '../Utils/Constants';
import AppNavbar from "../Navbar/Navbar";
import Button from 'react-bootstrap/Button';

import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

import '../Style/CampaignDetails.css';
import jwt_decode from "jwt-decode";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CampaignDetails = () => {
    const { id } = useParams();
    const [rol, setRol] = useState('');
    const [existVote, setExistVote] = useState(false);
    const [user, setUser] = useState('');
    const [campaign, setCampaign] = useState(null);
    const [candidates, setCandidates] = useState([]);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCampaignDetails = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    navigate('/login');
                }

                const decoded = jwt_decode(token);
                setRol(decoded.rol);
                setUser(decoded.username);

               let headers = {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                }

                const [campaignInfo, candidatesInfo] = await Promise.all([
                    fetch(`${API_URLS.BASE_PATH}/api/campaign/${id}`, {
                        method: 'GET',
                        headers
                    }),
                    fetch(`${API_URLS.BASE_PATH}/api/candidates/${id}`, {
                        method: 'GET',
                        headers
                    }),
                ]);


                try {
                    const verifyVote = await fetch(`${API_URLS.BASE_PATH}/api/vote/${id}/${decoded.username}`, {
                        method: 'GET',
                        headers
                    });
                    if (verifyVote.status === 200) {
                        setExistVote(true);
                    } else if (verifyVote.status === 404) {
                        console.log("No se encontró un voto previo para este usuario.");
                    } else if (verifyVote.status === 403 || verifyVote.status === 401) {
                        console.error('Token invalido o expirado');
                        localStorage.removeItem('token');
                        navigate('/login');
                    } else {
                        console.error("Error inesperado al verificar el voto:", verifyVote.status);
                    }
                } catch (voteError) {
                    console.error("Error al intentar verificar el voto:", voteError);
                }

                const dataCampaign = await campaignInfo.json();
                const dataCandidate = await candidatesInfo.json();

                if (campaignInfo.status === 403 || campaignInfo.status === 401 || candidatesInfo.status === 403 || candidatesInfo.status === 401) {
                    console.error('Token invalido o expirado');
                    localStorage.removeItem('token');
                    navigate('/login');
                }

                if (campaignInfo.ok) {
                    setCampaign(dataCampaign);
                }

                if (candidatesInfo.ok) {
                    setCandidates(dataCandidate);
                }


            } catch (error) {
                console.error('Error al cargar los detalles de la campaña:', error);
                setError('Hubo un error en el servidor.');
            }
        };

        fetchCampaignDetails();
    }, [id]);

    const handleVote = (candidateId) => {
        console.log(`Votar por candidato: ${candidateId}`);
        const token = localStorage.getItem('token');
        const data = {
            campaign_id: id,
            candidate_id: candidateId,
            username: user
        };

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
            },
            body: JSON.stringify(data),
        }

        const addVote = async () => {
            try {
                const response = await fetch(`${API_URLS.BASE_PATH}/api/vote`, requestOptions);
                const responseData = await response.json();

                if (response.ok) {
                    console.log('Voto registrado:', responseData);
                    setExistVote(true);
                    window.location.reload();
                } else if (response.status === 403 || response.status === 401) {
                    console.error('Token invalido o expirado');
                    localStorage.removeItem('token');
                    navigate('/login');
                } else {
                    console.error('Error al registrar el voto:', responseData.error);
                }
            } catch (error) {
                console.error('Error al enviar la campaña:', error);
                setError('Hubo un error en el servidor.');
            }
        }

        addVote();

    };

    const data = {
        labels: candidates.map(candidate => candidate.name),
        datasets: [
            {
                label: 'Votos',
                data: candidates.map(candidate => candidate.count),
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Votos por Candidato',
            },
        },
    };

    if (error) {
        return <p>{error}</p>;
    }

    if (!campaign) {
        return <p>Cargando...</p>;
    }

    return (
        <div className="campaign-details-page">
            <AppNavbar />
            <div className="campaign-details-container">
                <h1>{campaign.title}</h1>
                <p>{campaign.description}</p>

                <div className="campaign-graph">
                    <Bar data={data} options={options}/>
                </div>

                <br/>
                <h3>{campaign.status === 'ACTIVE' ? 'Votación activa' : 'Votación finalizada'}</h3>
                <h2>Candidatos afiliados</h2>
                <div className="candidates-grid">
                    {candidates.map(candidate => (
                        <div key={candidate._id} className="candidate-card">
                            <img src={candidate.image} alt={candidate.name} className="candidate-image"/>
                            <h4>{candidate.name}</h4>
                            <p>{candidate.description}</p>
                            {
                                !existVote && campaign.status === 'ACTIVE' && rol === 'VOTANTE' && (
                                <Button variant="danger" onClick={() => handleVote(candidate._id)}>Votar</Button>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CampaignDetails;
